import AppBtn, {
  AppBtnColor,
  AppBtnRadius,
  AppBtnSize,
} from 'components/btn/AppBtn'
import { useEffect, useRef, useState } from 'react'
import Popup, { PopupSize } from 'components/popup/Popup'
import {
  IBuffetMilletDto,
  IBuffetMilletRequest,
} from 'core/api/dto/BuffetMilletDto'
import { FrozeMillet } from '../FrozeMillet/FrozeMillet'
import { AppScrollWrapperNew } from 'widgets/AppScrollWrapper/AppScrollWrapper'
import { AppInput } from 'components/AppInput/AppInput'
import { useGetBuffetMilletQuery } from 'core/api/BuffetMilletApi'
import { useTranslation } from 'react-i18next'
import {
  useUpdatePlanMenuCloseDimensionByOrderLineMutation,
  useUpdatePlanMenuCloseDimensionMutation,
} from 'core/api/PlanMenuCloseDimensionApi'
import {
  AppNotification,
  NotificationType,
} from 'components/notification/Notification'
interface IPopupProps {
  setIsShowPopup: (arg: boolean) => void
  isOneDimension: boolean
  dimensionId?: string | null
  dishId?: string | null
}

const AddMilletPopup = ({
  setIsShowPopup,
  isOneDimension,
  dimensionId,
  dishId,
}: IPopupProps) => {
  const { t } = useTranslation()
  const refInput = useRef<HTMLInputElement>(null)
  const [updatePlanMenuCloseDimension] =
    useUpdatePlanMenuCloseDimensionMutation()
  const [updatePlanMenuCloseDimensionByOrderLine] =
    useUpdatePlanMenuCloseDimensionByOrderLineMutation()
  const [inputValue, setInputValue] = useState<string>('')
  const closePopup = () => {
    setIsShowPopup(false)
  }

  const saveMillet = () => {
    if (currentMillet) {
      if (!!isOneDimension && dimensionId) {
        updatePlanMenuCloseDimension({
          id: Number(dimensionId),
          data: { milletType: currentMillet.id },
        })
          .unwrap()
          .then(() => {
            AppNotification({
              msg: t('Тара добавлена'),
              type: NotificationType.success,
            })
            closePopup()
          })
      }
      if (!isOneDimension && dishId) {
        updatePlanMenuCloseDimensionByOrderLine({
          orderLineId: Number(dishId),
          data: { milletType: currentMillet.id },
        })
          .unwrap()
          .then(() => {
            AppNotification({
              msg: t('Тара добавлена'),
              type: NotificationType.success,
            })
            closePopup()
          })
      }
      // updatePlanMenuCloseDimension
    }
  }
  const [currentMillet, setCurrentMillet] = useState<IBuffetMilletDto | null>()
  const [milletList, setMilletList] = useState<IBuffetMilletDto[]>([])
  const [params, setParams] = useState<IBuffetMilletRequest | null>({
    limit: 10,
    offset: 0,
    search: '',
    archived: '0',
  })
  const { data: dataMillet } = useGetBuffetMilletQuery({
    ...params,
    archived: '0',
  })
  useEffect(() => {
    const handler = setTimeout(() => {
      if (inputValue === '') {
        setParams({ limit: 10, offset: 0, search: inputValue })
      } else {
        setParams({ limit: 10, offset: 0, search: inputValue })
      }
    }, 500)

    return () => {
      clearTimeout(handler)
    }
  }, [inputValue])

  useEffect(() => {
    if (params?.offset === 0 && !!dataMillet) {
      setMilletList(dataMillet?.results)
    } else if (params?.offset !== 0 && !!dataMillet) {
      setMilletList((prev) => [...prev, ...dataMillet?.results])
    }
  }, [dataMillet])
  const inputSearchFn = (value: string) => {
    setInputValue(value)
  }

  const nextPageHandler = () => {
    setParams({
      limit: 10,
      offset: (params?.offset ? params?.offset : 0) + 10,
      search: inputValue,
    })
  }
  return (
    <Popup size={PopupSize.md} borderRadiusMin={true} closePopup={closePopup}>
      <div className="popup-content-millet">
        <div className="header-popup">
          <h3>{currentMillet ? currentMillet.milletName : t('Выбор тары')}</h3>
          <div className="popup-icon-close" onClick={closePopup}>
            <i className="an-ico an-ico-close" />
          </div>
        </div>

        <AppInput
          ref={refInput}
          value={inputValue}
          onChange={inputSearchFn}
          placeholder={'Поиск...'}
          fullWidth
          clear
        />

        <div className="wrap-millet">
          <AppScrollWrapperNew theme="dropdown">
            {' '}
            {milletList?.map((item, index) => (
              <FrozeMillet
                key={index}
                data={item}
                currentMillet={currentMillet?.id}
                onClick={() => setCurrentMillet(item)}
              />
            ))}
            {!!dataMillet?.next && (
              <div onClick={(e) => e.stopPropagation()} className="mt-10">
                <AppBtn
                  title="Показать ещё"
                  sized={AppBtnSize.fullWidth}
                  color={AppBtnColor.lightViolet}
                  radius={AppBtnRadius.base}
                  onClick={nextPageHandler}
                />
              </div>
            )}
          </AppScrollWrapperNew>
        </div>

        <div className="buttons-block">
          <AppBtn
            title={'Отменить'}
            color={AppBtnColor.outlineViolet}
            iconClassName={'close'}
            sized={AppBtnSize.md}
            onClick={closePopup}
          />
          <AppBtn
            iconClassName={'save'}
            title={'Сохранить'}
            sized={AppBtnSize.md}
            color={AppBtnColor.violetWhite}
            onClick={() => {
              saveMillet()
            }}
          />
        </div>
      </div>
    </Popup>
  )
}

export default AddMilletPopup
